import { Link } from "react-router-dom";
import { KineticText } from "../components/KineticText";
import { ParticleField } from "../components/ParticleField";

export default function NotFound() {
  return (
    <main className="grain relative flex min-h-screen items-center overflow-hidden bg-night pt-24" data-testid="not-found-page">
      <ParticleField className="absolute inset-0 h-full w-full" />
      <div className="relative mx-auto max-w-3xl px-4 text-center">
        <h1 className="font-syne text-7xl font-extrabold tracking-tight text-white sm:text-9xl">
          <KineticText
            lines={[
              <span key="4" className="bg-gradient-to-r from-spark to-ember bg-clip-text text-transparent">404</span>,
            ]}
            delay={0.2}
          />
        </h1>
        <p className="mt-6 text-base text-slate-400 sm:text-lg">
          This grid coordinate doesn't exist — let's get you back on the map.
        </p>
        <Link
          to="/"
          data-testid="not-found-home-btn"
          className="mt-10 inline-flex items-center rounded-full bg-gradient-to-r from-spark to-ember px-8 py-4 text-sm font-bold text-night transition-transform duration-300 hover:scale-105"
        >
          Back to Home
        </Link>
      </div>
    </main>
  );
}
